import React, { useMemo } from 'react';
import { Accept } from 'react-dropzone';

import { Flex, Box, Link, Text } from '@chakra-ui/react';

import {
  getAcceptedExtensions,
  getImportTemplateByType,
  ImportTemplateType,
} from './shared';

type FileImportHelperProps = {
  accept: Accept;
  type: ImportTemplateType;
};

const FileImportHelper: React.FC<FileImportHelperProps> = ({
  accept,
  type,
}) => {
  const acceptedExtensions = useMemo(
    () => getAcceptedExtensions(accept),
    [accept],
  );
  const template = useMemo(() => getImportTemplateByType(type), [type]);

  return (
    <Box mb={4}>
      <Flex flexDirection="row" gap={2} fontSize="xs" color="gray.700">
        Formatos aceitos:{' '}
        {acceptedExtensions.map((extension) => (
          <Box
            key={extension}
            px={2}
            py={1}
            borderWidth={1}
            borderColor="gray.200"
            borderRadius="md"
            bg="gray.50"
            color="gray.600"
            fontSize="xx-small"
            fontWeight="medium"
            lineHeight="shorter"
          >
            {extension}
          </Box>
        ))}
      </Flex>

      {template ? (
        <Text mt={1} fontSize="xs" color="gray.700">
          Precisa de um modelo?{' '}
          <Link
            href={template.href}
            download={template.downloadName}
            color="blue.400"
            fontWeight="medium"
            target="_blank"
            rel="noopener noreferrer"
          >
            {template.title}
          </Link>
          .
        </Text>
      ) : null}
    </Box>
  );
};

export default FileImportHelper;
